import { render, staticRenderFns } from "./costPerPiece.vue?vue&type=template&id=1264605a&scoped=true"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"
import style0 from "./costPerPiece.vue?vue&type=style&index=0&id=1264605a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1264605a",
  null
  
)

export default component.exports